module.exports = __webpack_public_path__ + "static/Light Full Color-2ca22d516615a83e791ec4b58e9be0ae.png";